import { JsonConverter, JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo, MapStringTo, Nullable, Object_Unknown } from "../../base-types";
import { PageResourceMenusConverter } from "../../converters/page-resource-menus-converter";
import { PageResourceZonesConverter } from "../../converters/page-resource-zones-converter";
import Resource from "../resource";
import { LanguageResource } from "./language-resource";
import { MenuItem } from "./menu-item";
import { PageComponentResource } from "./page-component-resource";
import { PortalSectionResource } from "./portal-section-resource";

@JsonObject()
export class PageResource extends Resource {
    @JsonProperty("id")
    id: number;

    @JsonProperty("identifier")
    identifier: string;

    @JsonProperty("name")
    name: string;

    @JsonProperty("title")
    title: MapCultureTo<string>;

    @JsonProperty("path")
    path: MapCultureTo<string>;

    @JsonProperty("data")
    data: Object_Unknown;

    @JsonProperty("is_title_visible")
    isTitleVisible: boolean = false;

    @JsonProperty("is_in_sitemap")
    isInSiteMap: boolean = false;

    @JsonProperty("is_in_menu")
    isInMenu: boolean = false;

    @JsonProperty("zones")
    @JsonConverter(PageResourceZonesConverter)
    zones: MapStringTo<Array<PageComponentResource>> = {};

    @JsonProperty("sections")
    @JsonElementType(PortalSectionResource)
    sections: Array<PortalSectionResource> = [];

    @JsonProperty("menus")
    @JsonConverter(PageResourceMenusConverter)
    menus: MapStringTo<Array<MenuItem>>;

    @JsonProperty("languages")
    @JsonElementType(LanguageResource)
    languages: Array<LanguageResource> = [];

    @JsonProperty("messages")
    messages: MapStringTo<string>;

    @JsonProperty("back_destination")
    backDestination: Nullable<string>;
}
